import React, { useState, useEffect } from 'react';
import SignUp from "./SignUp";
import DartsDesign from "./DartsDesign";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';


import '../App.css';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import FormReferAFriend from "./FormReferAFriend";
import SelectLabels from "./SelectLabels";
import DashboardTopMenu from "./DashboardTopMenu";
import GridView from "./GridView";


import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import { useHistory } from "react-router-dom";

import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    copyright: {
      padding: theme.spacing(2,2),
      alignItems: 'center',
      flex: 1,
      justifyContent: 'center'
    },
    nested: {
      paddingLeft: theme.spacing(1),
    },

    outerDiv: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between'

    },
    leftDiv: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: 1
    },
    rightDiv: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: 1
    }
  }),
);

export default function RouteAdminUserGrowth(props) {

  

  const classes = useStyles();
  const theme = useTheme();

  useEffect(() => {

    if(!props.userDetails.user_loged_in) {
  
      changeHistory('/AdminUserGrowth', '/')
    } else {
      //changeHistory('/ReferAFriend', '/SignUp')
    }
  }, []);
  
  const history = useHistory();

  const changeHistory = (_from, _to) => {
    history.push(_to, { from: _from })
  };

  const columns = [
    { field: 'userType', headerName: 'User Type', width: 250, editable: false },
    {
      field: '_1day',
      headerName: '1 Day',
      type:'number',
      width: 130,
      editable: false,
    },
    {
      field: '_7days',
      headerName: '7 Days',
      type:'number',
      width: 130,
      editable: false,
    },
    {
      field: '_15days',
      headerName: '15 Days',
      type:'number',
      width: 130,
      editable: false,
    },
    {
      field: '_30days',
      headerName: '30 Days',
      type:'number',
      width: 130,
      editable: false,
    },
    {
      field: '_30dayaverage',
      headerName: '30 Day Average',
      type:'number',
      width: 130,
      editable: false,
    },
    {
      field: 'sinceinception',
      headerName: 'Since Inception',
      type:'number',
      width: 130,
      editable: false,
    },
  ];
  
  const rows = [
    {
      id: 1,
      userType: 'User',
      _1day: 300,
      _7days: 2000,
      _15days: 3500,
      _30days: 9875,
      _30dayaverage: 329.16,
      sinceinception: 14425,
    },
    {
      id: 2,
      userType: 'Contributor',
      _1day: 200,
      _7days: 3000,
      _15days: 4500,
      _30days: 8899,
      _30dayaverage: 451.25,
      sinceinception: 25000,
    },
    {
      id: 3,
      userType: 'User',
      _1day: 300,
      _7days: 2000,
      _15days: 3500,
      _30days: 9875,
      _30dayaverage: 329.16,
      sinceinception: 14425,
    },
    {
      id: 4,
      userType: 'Contributor',
      _1day: 300,
      _7days: 2000,
      _15days: 3500,
      _30days: 9875,
      _30dayaverage: 329.16,
      sinceinception: 14425,
    },
    {
      id: 5,
      userType: 'User',
      _1day: 300,
      _7days: 2000,
      _15days: 3500,
      _30days: 9875,
      _30dayaverage: 329.16,
      sinceinception: 14425,
    },
  ];

  return (
    <Grid container spacing={2} columns={12} direction="row" justifyContent="space-between" alignItems="center" style={{width:'100%', margin: 0}} >
        <DashboardTopMenu _apiLogOff={props._apiLogOff} userDetails={props.userDetails} />
        <Grid item xs={12} sm={12} md={12} lg={12} align="center" justify="center">
          <GridView columns={columns} rows={rows} />
        </Grid>
    </Grid>
  );
}